import {
  Form,
  Input,
  message,
  Radio,
  Select,
  Space,
  Button,
  Card,
  Collapse,
  Spin,
  Row,
  Col,
  Divider,
  Image,
  Modal,
  Grid,
} from 'antd';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppTable,
  generateFullName,
  getStandardError,
  HeaderSection,
  IAppTableColumn,
  PAGE_SIZE_OPTIONS,
  useFetchList,
} from '@qlibs/react-components';
import { httpRequest } from '../../helpers/api';
import { generateFormRules } from '../../helpers/formRules';
import styled from 'styled-components';
import { ICreateUser, initialUser } from './types/user.type';
import CONFIG from '../../const/config';
import SectionContent from '../../components/SectionContent';
import { getErrorMessage } from '@qlibs/react-components';
import {
  CustomFormItemPer1,
  CustomFormItemPer2,
  CustomFormItemPer3,
} from './components/CustomFormItem';
import config from '../../const/config';
import { ULTRA_SUPER_ADMIN_ROLE_ID } from '../../const/config';
import { generate } from 'generate-password-browser';
import { Checkbox } from 'antd/lib';
import { RoleProperties } from '../../types/role.type';
import { CompanyProperties } from '../company/types/company.type';
import { GroupProperties } from '../group/types/group.type';
import {
  AdminMobileActionButton,
  AdminMobileCheckbox,
  AdminMobileChooseCompanyModal,
  AdminMobileCompanyCopy,
  AdminMobileCompanyHeader,
  AdminMobileCompanyTable,
  AdminMobileField,
  AdminMobileForm,
  AdminMobileHeader,
  AdminMobileHeaderActions,
  AdminMobilePage,
  AdminMobilePasswordRow,
  AdminMobileSecondaryButton,
  AdminMobileSection,
  AdminMobileSectionHeader,
} from './mobile';

type Props = {
  userType?: 'admin' | 'customer';
};

const { Option } = Select;

const UserCreate = (props: Props) => {
  const navigate = useNavigate();
  const screens = Grid.useBreakpoint();
  const [form] = Form.useForm();
  const [isLoadingAction, setIsLoadingAction] = React.useState<boolean>(false);
  const [customer, setCustomer] = React.useState<ICreateUser>(initialUser);

  const [password, setPassword] = React.useState<string>();
  const [isCheckedSendAccountInformation, setIsCheckedSendAccountInformation] =
    React.useState<boolean>(false);

  const [isModalCompanyOpen, setIsModalCompanyOpen] =
    React.useState<boolean>(false);

  const [tmpCompanies, setTmpCompanies] = React.useState<CompanyProperties[]>(
    [],
  );
  const [companies, setCompanies] = React.useState<CompanyProperties[]>([]);
  const selectedRoleId = Form.useWatch('roleId', form);
  const isUltraSuperAdminUser = selectedRoleId === ULTRA_SUPER_ADMIN_ROLE_ID;
  const isMobile = screens.md === false;

  const { data: roles, isLoading: isLoadingRole } =
    useFetchList<RoleProperties>({
      httpRequest: httpRequest as any,
      endpoint: 'roles',
      limit: 1000,
    });
  // const listRole = roles.filter((role) =>
  //   props.userType === "admin"
  //     ? role.roleName.toLowerCase().includes("admin")
  //     : !role.roleName.toLowerCase().includes("admin")
  // );

  const listRole = roles;

  const [selectedGroupId, setSelectedGroupId] = React.useState<string>();

  const { data: dataGroups, isLoading: isLoadingGroup } = useFetchList<GroupProperties>({
    httpRequest: httpRequest as any,
    endpoint: 'group',
    limit: 1000,
  });

  useEffect(() => {
    const roleId =
      roles.find((role) =>
        role.roleName.toLowerCase().includes(props.userType || ''),
      )?.roleId || '';
    if (roleId) {
      form.setFieldValue('roleId', roleId);
    }
  }, [roles]);

  const createUser = async (value: ICreateUser) => {
    try {
      setIsLoadingAction(true);

      const fullName = generateFullName({
        firstName: value.firstName,
        middleName: value.middleName,
        lastName: value.lastName,
      });
      const name = value.name || fullName;

      const formData = {
        name,
        firstName: value.firstName || name,
        middleName: value.middleName,
        lastName: value.lastName,
        email: value.email,
        password: value.password,
        phone: value.phone || null,
        roleId: value.roleId ? value.roleId : listRole[0]?.roleId,
        sendAccountInformation: isCheckedSendAccountInformation,
        status: value.status,
        companyIds: companies.map((company) => company.companyId),
      };

      await httpRequest.post('/users', formData);

      message.success(`Success add ${name}`);
      navigate('/' + props.userType);
    } catch (error) {
      getStandardError(error, {
        triggerFormValidation: true,
        formRef: form,
        showToast: true,
      });
    } finally {
      setIsLoadingAction(false);
    }
  };

  const handleSubmit = async (values: ICreateUser) => {
    createUser(values);
  };

  const generatePassword = () => {
    var password = generate({
      length: Math.floor(Math.random() * (16 - 14 + 1) + 14),
      numbers: true,
    });
    // setPassword(password)
    form.setFieldValue('password', password);
  };

  const handleSelectedCompanies = (company: CompanyProperties) => {
    const result = tmpCompanies.find(
      (value: CompanyProperties) => value.companyId === company.companyId,
    );

    if (!result) {
      setTmpCompanies((prevCompanies) => [...prevCompanies, company]);
    } else {
      setTmpCompanies((prevCompanies) =>
        prevCompanies.filter(
          (value: CompanyProperties) => value.companyId !== company.companyId,
        ),
      );
    }
  };

  const handleSaveSelectedCompany = () => {
    setCompanies([...tmpCompanies]);
    setIsModalCompanyOpen(false);
  };

  const handleOpenCompanyModal = () => {
    setSelectedGroupId(undefined);
    setIsModalCompanyOpen(true);
  };

  const handleSelectedGroup = (value: string | string[]) => {
    setSelectedGroupId(Array.isArray(value) ? value[0] : value || undefined);
  };

  const handleRemoveCompany = (company: CompanyProperties) => {
    setTmpCompanies((prevCompanies) =>
      prevCompanies.filter(
        (value: CompanyProperties) => value.companyId !== company.companyId,
      ),
    );
    setCompanies((prevCompanies) =>
      prevCompanies.filter(
        (value: CompanyProperties) => value.companyId !== company.companyId,
      ),
    );
  };

  const columns: IAppTableColumn<CompanyProperties>[] = [
    {
      title: 'FLAG',
      dataIndex: 'imageLink',
      key: 'imageLink',
      render: (value, _) => (
        <Image
          src={value}
          width={40}
          height={40}
          style={{
            objectFit: 'contain',
            background: '#f4f6f9',
            borderRadius: 4,
          }}
          fallback='/images/flag-not-found.png'
        />
      ),
    },
    {
      title: 'NAME',
      dataIndex: 'name',
      key: 'name',
      type: 'detail',
      keyId: 'companyId',
      render: (value, records) => (records.name ? `${records.name}` : 'N/A'),
    },
    {
      title: 'GROUP',
      dataIndex: 'groupId',
      key: 'groupId',
      render: (_, records) => {
        const group =
          dataGroups.find(
            (item: GroupProperties) => item.groupId === records.groupId,
          ) ||
          dataGroups.find((item: GroupProperties) =>
            item.companies?.some(
              (company: CompanyProperties) =>
                company.companyId === records.companyId,
            ),
          ) ||
          records.group;

        return group
          ? group.nickname
            ? `(${group.nickname}) ${group.name}`
            : group.name || 'N/A'
          : 'N/A';
      },
    },
    {
      title: 'ACTION',
      dataIndex: 'action',
      key: 'action',
      render: (value, records) => (
        <Button danger onClick={() => handleRemoveCompany(records)}>
          Delete
        </Button>
      ),
    },
  ];

  const columnsModal: IAppTableColumn<CompanyProperties>[] = [
    {
      title: '',
      key: 'isSelected',
      render: (value, records) => {
        const isChecked = !!tmpCompanies.find(
          (val) => val.companyId === records.companyId,
        );

        return (
          <Checkbox
            checked={isChecked}
            onChange={() => {
              handleSelectedCompanies(records);
            }}
          />
        );
      },
    },
    {
      title: 'FLAG',
      dataIndex: 'imageLink',
      key: 'imageLink',
      render: (value, _) => (
        <Image
          src={value}
          width={40}
          height={40}
          style={{
            objectFit: 'contain',
            background: '#f4f6f9',
            borderRadius: 4,
          }}
          fallback='/images/flag-not-found.png'
        />
      ),
    },
    {
      title: 'NAME',
      dataIndex: 'name',
      key: 'name',
      type: 'detail',
      keyId: 'companyId',
      render: (value, records) => (records.name ? `${records.name}` : 'N/A'),
    },
  ];

  const renderMobileContent = () => (
    <AdminMobilePage>
      <AdminMobileHeader
        title={props.userType === 'admin' ? 'Admin' : 'Customer'}
        onBack={() => navigate('/' + props.userType)}
        action={
          <AdminMobileHeaderActions>
            <AdminMobileSecondaryButton
              onClick={() => navigate('/' + props.userType)}
            >
              Cancel
            </AdminMobileSecondaryButton>
            <AdminMobileActionButton
              type="primary"
              loading={isLoadingAction}
              onClick={() => form.submit()}
            >
              Save
            </AdminMobileActionButton>
          </AdminMobileHeaderActions>
        }
      />

      <AdminMobileForm>
        <Form
          form={form}
          name="profileForm"
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
        >
          <AdminMobileSection $bordered>
            <AdminMobileSectionHeader>
              <h2>Information</h2>
              <p>Detail information about admin</p>
            </AdminMobileSectionHeader>

            {CONFIG.user.modeEditName === 'fullname' ? (
              <AdminMobileField
                label="Name"
                name="name"
                rules={generateFormRules('Name', [
                  'required',
                  'letter-and-space',
                  'max-text-length',
                ])}
              >
                <Input placeholder="Input name" />
              </AdminMobileField>
            ) : (
              <React.Fragment>
                <AdminMobileField
                  label="First Name"
                  name="firstName"
                  rules={generateFormRules('First Name', ['required'])}
                >
                  <Input placeholder="Input first name" />
                </AdminMobileField>
                <AdminMobileField label="Middle Name" name="middleName">
                  <Input placeholder="Input middle name" />
                </AdminMobileField>
                <AdminMobileField label="Last Name" name="lastName">
                  <Input placeholder="Input last name" />
                </AdminMobileField>
              </React.Fragment>
            )}

            <AdminMobileField
              label="Email"
              name="email"
              rules={generateFormRules('Email', ['required', 'email'])}
            >
              <Input placeholder="Input email address" />
            </AdminMobileField>

            <AdminMobilePasswordRow>
              <AdminMobileField
                label="Password"
                name="password"
                rules={generateFormRules('Password', ['required', 'password'])}
              >
                <Input.Password placeholder="Input password" />
              </AdminMobileField>
              <Button onClick={generatePassword}>Generate</Button>
            </AdminMobilePasswordRow>

            <AdminMobileField
              label="Phone Number"
              name="phone"
              rules={generateFormRules(
                'Phone number',
                config.user.phoneRequired
                  ? ['required', 'phoneNumber']
                  : ['phoneNumber'],
              )}
            >
              <Input
                onChange={(event) =>
                  setCustomer({ ...customer, phone: event.target.value })
                }
                placeholder="Input phone number"
              />
            </AdminMobileField>

            {props.userType === 'admin' && listRole.length > 1 ? (
              <AdminMobileField
                label="Role"
                name="roleId"
                rules={[
                  {
                    message: 'The Role is required.',
                    required: true,
                  },
                ]}
              >
                <Select placeholder="Select role" style={{ width: '100%' }}>
                  {listRole.map((role, key) => (
                    <Option key={key} value={role.roleId}>
                      {role.roleName}
                    </Option>
                  ))}
                </Select>
              </AdminMobileField>
            ) : null}

            <AdminMobileField
              label="Status"
              name="status"
              rules={[
                {
                  message: 'The Status is required.',
                },
              ]}
            >
              <Radio.Group value={customer.status} defaultValue="active">
                <CustomRadio value="active">Active</CustomRadio>
                <CustomRadio value="inactive">Inactive</CustomRadio>
              </Radio.Group>
            </AdminMobileField>

            <AdminMobileCheckbox>
              <Checkbox
                onChange={(e) =>
                  setIsCheckedSendAccountInformation(e.target.checked)
                }
              />
              <span>Send account information & password via email</span>
            </AdminMobileCheckbox>
          </AdminMobileSection>
        </Form>

        {!isUltraSuperAdminUser ? (
          <AdminMobileSection>
            <AdminMobileCompanyHeader>
              <AdminMobileCompanyCopy>
                <h2>Company</h2>
                <p>List of companies</p>
              </AdminMobileCompanyCopy>
              <AdminMobileActionButton
                type="primary"
                onClick={handleOpenCompanyModal}
              >
                Add Company
              </AdminMobileActionButton>
            </AdminMobileCompanyHeader>

            <AdminMobileCompanyTable
              rowKey="companyId"
              columns={columns as any}
              dataSource={companies}
              size="small"
              scroll={{ x: 760 }}
              pagination={false}
            />
          </AdminMobileSection>
        ) : null}
      </AdminMobileForm>

      {!isUltraSuperAdminUser ? (
        <AdminMobileChooseCompanyModal
          title="Choose Company"
          open={isModalCompanyOpen}
          onCancel={() => setIsModalCompanyOpen(false)}
          width={350}
          onOk={handleSaveSelectedCompany}
          okText="OK"
          okButtonProps={{ disabled: !selectedGroupId }}
        >
          <Collapse
            accordion
            activeKey={selectedGroupId}
            onChange={handleSelectedGroup}
            items={dataGroups.map((group: GroupProperties) => ({
              key: group.groupId,
              label: group.nickname
                ? `(${group.nickname}) ${group.name}`
                : group.name,
              children: (
                <>
                  <div style={{ fontWeight: 600, marginBottom: 8 }}>
                    Choose Company
                  </div>
                  <AdminMobileCompanyTable
                    rowKey="companyId"
                    columns={columnsModal as any}
                    dataSource={group.companies || []}
                    loading={isLoadingGroup}
                    size="small"
                    scroll={{ x: 743 }}
                    pagination={false}
                  />
                </>
              ),
            }))}
          />
        </AdminMobileChooseCompanyModal>
      ) : null}
    </AdminMobilePage>
  );

  return (
    <React.Fragment>
      {isMobile ? (
        renderMobileContent()
      ) : (
        <>
          <HeaderSection
        icon='back'
        title={'Add ' + (props.userType === 'admin' ? 'Admin' : 'Customer')}
        subtitle={'Create new user'}
        showCancelButton
        showSaveButton
        isLoading={isLoadingAction}
        onSave={() => form.submit()}
      />

      <Card>
        <SectionContent
          groupTitle={`User Information`}
          subTitle='These are data user information, you can change anything'
        >
          <Form
            form={form}
            name='profileForm'
            layout='vertical'
            onFinish={handleSubmit}
            autoComplete='off'
            style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}
          >
            {CONFIG.user.modeEditName === 'fullname' ? (
              <CustomFormItemPer1
                label='Name'
                name='name'
                rules={generateFormRules('Name', [
                  'required',
                  'letter-and-space',
                  'max-text-length',
                ])}
              >
                <Input placeholder='Input name' />
              </CustomFormItemPer1>
            ) : (
              <React.Fragment>
                <CustomFormItemPer3
                  label='First Name'
                  name='firstName'
                  rules={generateFormRules('First Name', ['required'])}
                >
                  <Input placeholder='Input first name' />
                </CustomFormItemPer3>
                <CustomFormItemPer3 label='Middle Name' name='middleName'>
                  <Input placeholder='Input middle name' />
                </CustomFormItemPer3>
                <CustomFormItemPer3 label='Last Name' name='lastName'>
                  <Input placeholder='Input last name' />
                </CustomFormItemPer3>
              </React.Fragment>
            )}

            <CustomFormItemPer3
              label='Email'
              name='email'
              rules={generateFormRules('Email', ['required', 'email'])}
            >
              <Input placeholder='Input email address' />
            </CustomFormItemPer3>

            <CustomFormItemPer3
              label='Password'
              name='password'
              rules={generateFormRules('Password', ['required', 'password'])}
            >
              <Input.Password
                // onChange={(e) => setPassword(e.target.value)}
                // value={password}
                placeholder='Input password'
              />
            </CustomFormItemPer3>

            <CustomFormItemPer3>
              <Button
                style={{
                  backgroundColor: '#DDDDDD',
                  // width: '30%',
                  marginLeft: '10px',
                  marginTop: '30px',
                }}
                onClick={generatePassword}
              >
                Generate Password
              </Button>
            </CustomFormItemPer3>

            <CustomFormItemPer1
              label='Phone Number'
              name='phone'
              rules={generateFormRules(
                'Phone number',
                config.user.phoneRequired
                  ? ['required', 'phoneNumber']
                  : ['phoneNumber'],
              )}
            >
              <Input
                onChange={(event) =>
                  setCustomer({ ...customer, phone: event.target.value })
                }
                placeholder='Input phone number'
              />
            </CustomFormItemPer1>

            {/* {props.userType === "admin" ? (
          <CustomFormItemPer1
            label="Email"
            name="email"
            rules={generateFormRules("Email", ["required", "email"])}
          >
            <Input
              onChange={(event) =>
                setCustomer({ ...customer, email: event.target.value })
              }
              placeholder="Input email address"
            />
          </CustomFormItemPer1>
        ) : (
          <CustomFormItemPer1
            label="Phone Number"
            name="phone"
            rules={generateFormRules("Phone number", [
              "required",
              "phoneNumber",
            ])}
          >
            <Input
              onChange={(event) =>
                setCustomer({ ...customer, phone: event.target.value })
              }
              placeholder="Input number"
            />
          </CustomFormItemPer1>
        )} */}

            {props.userType === 'admin' && listRole.length > 1 ? (
              <CustomFormItemPer1
                label='Role'
                name='roleId'
                rules={[
                  {
                    message: 'The Role is required.',
                    required: true,
                  },
                ]}
              >
                <Select placeholder='Select role' style={{ width: '100%' }}>
                  {listRole.map((role, key) => (
                    <Option key={key} value={role.roleId}>
                      {role.roleName}
                    </Option>
                  ))}
                </Select>
              </CustomFormItemPer1>
            ) : (
              <React.Fragment></React.Fragment>
            )}

            <CustomFormItemPer1
              label='Status'
              name='status'
              rules={[
                {
                  message: 'The Status is required.',
                },
              ]}
            >
              <Radio.Group value={customer.status} defaultValue='active'>
                <CustomRadio value='active'>Active</CustomRadio>
                <CustomRadio value='inactive'>Inactive</CustomRadio>
              </Radio.Group>
            </CustomFormItemPer1>
            <Checkbox
              onChange={(e) =>
                setIsCheckedSendAccountInformation(e.target.checked)
              }
            >
              Send account information & password via email
            </Checkbox>
          </Form>
        </SectionContent>
        <Divider />
        {!isUltraSuperAdminUser ? (
          <SectionContent groupTitle='Company' subTitle='List of companies'>
            <Row>
              <Col span={24}>
                <div className='flex flex-end mb-3'>
                  <Button
                    type='primary'
                    onClick={handleOpenCompanyModal}
                  >
                    Add Company
                  </Button>
                </div>
                <AppTable
                  keyId='companyId'
                  columns={columns}
                  data={companies}
                  pagination={false}
                />
              </Col>
            </Row>
          </SectionContent>
        ) : null}
      </Card>

      {!isUltraSuperAdminUser ? (
        <Modal
          title='Choose Company'
          open={isModalCompanyOpen}
          onCancel={() => setIsModalCompanyOpen(false)}
          width={'70%'}
          onOk={handleSaveSelectedCompany}
          okButtonProps={{ disabled: !selectedGroupId }}
        >
          <Collapse
            accordion
            activeKey={selectedGroupId}
            onChange={handleSelectedGroup}
            items={dataGroups.map((group: GroupProperties) => ({
              key: group.groupId,
              label: group.nickname
                ? `(${group.nickname}) ${group.name}`
                : group.name,
              children: (
                <>
                  <div style={{ fontWeight: 600, marginBottom: 8 }}>
                    Choose Company
                  </div>
                  <AppTable
                    keyId='companyId'
                    columns={columnsModal}
                    data={group.companies || []}
                    pagination={false}
                  />
                </>
              ),
            }))}
          />
        </Modal>
      ) : null}
        </>
      )}
    </React.Fragment>
  );
};

export default UserCreate;

const CustomRadio = styled(Radio)`
  margin-right: 5rem;
  .ant-radio-checked .ant-radio-inner {
    border-color: #1e1e1e;
    border-width: 2px;
    box-shadow: none;
  }
  .ant-radio:hover .ant-radio-inner {
    background-color: white;
  }
  .ant-radio-checked .ant-radio-inner:after {
    background-color: #1e1e1e;
  }
`;
